import { ERROR_AMOUNT_SOURCES, retierErrorOccurrences } from "score-common";

// #3142 (same fix as scribe-fe recordError, #1759). The Nth error of course
// is the Nth by MOVEMENT order (USEF DR122.5.b, docs/rules/usef/
// rulebook-dr-dressage-2026.pdf), not the Nth the admin happened to add. So
// an add appends a provisional rule-resolved entry carrying its movementNumber
// and runs the WHOLE set through retierErrorOccurrences, which re-derives every
// label and tier from movement order and promotes whichever entry lands on an
// eliminate tier into eliminations[] (fromError:true, #1831, DR122.5.b.3).
// Manual (amountSource manual / pre-#1756 hand-typed) entries pass through
// untouched and are not counted.
//
// Returns the next errors[]/eliminations[] arrays plus `outcome`: what the new
// entry resolved to, `{ eliminate: true, label }` or `{ label, points|percent,
// amountSource, movementNumber }`. Callers use the arrays to store and the
// outcome to preview, so what an admin is shown cannot disagree with what is
// stored (the #1756 "ONE place it is built" rule).
//
// retierErrorOccurrences rebuilds each rule entry without its `amountSource`
// stamp (the #1756 audit record), so it is re-applied here to the new entry and
// to every entry that already carried it.
export function appendRuleError(errors, eliminations, tiers, movementNumber) {
  const errorList = errors ?? [];
  const id = crypto.randomUUID();
  const stamped = new Set(
    errorList.filter((e) => e.amountSource === ERROR_AMOUNT_SOURCES.RULE).map((e) => e.id),
  );
  stamped.add(id);
  const retiered = retierErrorOccurrences(
    [
      ...errorList,
      { id, amountSource: ERROR_AMOUNT_SOURCES.RULE, movementNumber: movementNumber ?? null },
    ],
    eliminations ?? [],
    tiers,
  );
  const nextErrors = retiered.errors.map((e) =>
    stamped.has(e.id) ? { ...e, amountSource: ERROR_AMOUNT_SOURCES.RULE } : e,
  );
  const promoted = retiered.eliminations.find((e) => e.id === id);
  const outcome = promoted
    ? { eliminate: true, label: promoted.reason }
    : nextErrors.find((e) => e.id === id);
  return { errors: nextErrors, eliminations: retiered.eliminations, outcome };
}
